import React, { useEffect, useRef, useState } from "react";
import EReceiptVoucherForm from "./ERV-form";
import {
  Avatar,
  Chip,
  colors,
  Container,
  Divider,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { uri } from "../../../../../help/Api";
import TotalCard from "../../../../../components/TotalCard";
import ExternalFormSub from "../components/External-form-sub";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { useStylesHed } from "../../../../../St/comps/UseStyle";
import toast from "react-hot-toast";
import useFormDataCRUD from "../../../../../components/Hooks/useEDSCURD";
import EReceiptAPI from "../../../../../api/EReceipt";
import {
  ERVdefaultValues,
  getEndDept,
  ReFormatingData,
} from "../../../../../services/EReceiptVoucher-service";
import axios from "axios";
import { sto } from "../../../../../Context/InshData";
import EReceiptVoucherAppBar from "./EReceiptVoucher-AppBar";
import { getAccountOmlat } from "../../../../../services/omlat-services";
import { useTranslation } from "react-i18next";
import { getLS } from "../../../../../utils/useLS";
import moment from "moment";
import { addArchaiveFile, addMultiArchaiveFile, handleDownloadFiles, handleInputSearchCustomers, handleMultiDownloadFiles, viewHandleCustomers } from "../../../../Invs/BackEnd/components/SearchItemsFunction";
import { GetEmpFromOptions, isMobileDevice, useStylesSand } from "../external-exchange-voucher/EExchangeVoucher";

export const reloadGetsSanad = async (name, branch, onShow, defaultV) => {
  const tb = {
    wait: true,
    other: true,
    parms: {
      iempid: sto.empi,
      branch: branch == -1 ? sto.branchi : branch,
      tname: name,
      db_name:sto?.db_name,
    },
  };

  await axios
    .post(uri + "Res", tb)
    .then((res) => {
      onShow({ ...defaultV, id: res.data.other.lastid }, "new");
    })
    .catch((error) => {
      onShow(defaultV, "new");
    });
};

export default function EReceiptVoucher(props) {
  const { AutoOptions, prmis, fetchURL, isDialog, item, onClose,
    AutoOptionsB,
    branch,
    setBranch,db_name
  } = props;

  const StockOmlat = getAccountOmlat(
    AutoOptions.Stocks[0]?.acc_omlat ?? 1,
    AutoOptions.omlats
  );
  const BankOmlat = getAccountOmlat(
    AutoOptions.Banks[0]?.acc_omlat ?? 1,
    AutoOptions.omlats
  );
  const [branchT, setBranchT] = useState(sto.branchi);
  const [endBalance, setEndBalance] = useState(0.00);
  const [optionsStocks, setOptionsStocks] = useState(AutoOptions?.Stocks);

  const defaultV = isDialog
    ? ReFormatingData(item, AutoOptions)
    :
    {
      ...ERVdefaultValues,
      id: AutoOptions.other.lastid,
      emp: GetEmpFromOptions(sto.empi, AutoOptions.Users),
      stock: AutoOptions.Stocks[0],
      bank: AutoOptions.Banks[0],
      cust_omlat: [],
      cust_omla: { id: "-1", exchange: 1 },
      stock_omlat: StockOmlat ?? AutoOptions?.omlats,
      stock_omla: StockOmlat[0] ?? AutoOptions?.omlats[0],
      bank_omlat: BankOmlat ?? AutoOptions.omlats,
      bank_omla: BankOmlat[0] ?? AutoOptions.omlats[0],
      center: AutoOptionsB?.centerUser,
      date: moment(new Date()).format("YYYY-MM-DD"),
    };

  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,
    getRow
  } = useFormDataCRUD(
    EReceiptAPI.create,
    EReceiptAPI.update,
    EReceiptAPI.remove,
    undefined,
    defaultV,
    null,
    () => {
      // if (isDialog) onClose(true);
      // else fetchURL();
    },
    isDialog ? "edit" : "new",
    EReceiptAPI.GetRow
  );

  const { t } = useTranslation(["translation", "forms"]);

  const [selectCustomer, setselectCustomer] = useState(false);
  const [invOptions, setInvOptions] = useState([]);
  const [valueInv, setValueInv] = useState({ procId: "", netAmount: '', id: '', notes: '' });

  const [optionsCustomers, setOptionsCustomers] = useState(AutoOptions.Customers);
  const [listSelectApi, setListSelectApi] = useState([]);

  const countCustomers = AutoOptions.Customers.length == 300 ? true : false;
  const [searchCustText, setSearchCustText] = useState("");

  const searchTimeout = useRef(null);
  const handleInputSearchCust = (event, newValue, reason) => {
    const optionsAll = [...listSelectApi, ...AutoOptions.Customers]
    handleInputSearchCustomers(newValue, optionsAll, searchTimeout, setOptionsCustomers,
      countCustomers, 1, true, setSearchCustText, reason);
  };
  const handleIconSearchCust = () => {
    if (countCustomers && searchCustText) {
      const optionsAll = [...listSelectApi, ...AutoOptions.Customers]
      viewHandleCustomers(searchCustText, setOptionsCustomers, true, 1, -1, optionsAll);
    }
  };
  const changAutoCustomers = async (newValue, IsEdit) => {
    let end_dept1 = "0.0";
    setselectCustomer(false);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls =  `AccountReports/rptABalanceSumSand?branch=${-1}&&costCenter=${-1}&&acc_code=${newValue?.acc_no.toString()}
        &&custId=${newValue?.id}`
    } else {
      Urls =  `AccountReports/rptABalanceSumSand?branch=${-1}&&costCenter=${-1}&&acc_code=${newValue?.acc_no.toString()}
        &&custId=${newValue?.id}&&db_name=${db_name}`
    }
    await axios
      .get(
        uri +Urls
      )
      .then((res) => {
        end_dept1 = res.data?.deptTot?.end_Dept - res.data?.deptTot?.end_Credit;
        setInvOptions([{ procId: "", netAmount: '', id: '', notes: '' }, ...res.data?.invCredit]);
        setValueInv({ procId: "", netAmount: '', id: '', notes: '' });
        setselectCustomer(true);
      })
      .catch((res) => {
        toast.error(t("forms:customer-balance-fetch-failed"));
        console.log("erro", res.error);
        setselectCustomer(false);
        setInvOptions([]);
        setValueInv({ procId: "", netAmount: '', id: '', notes: '' });
      });
    if (!IsEdit) {
      const accOmlat = getAccountOmlat(newValue.acc_omlat ?? 1, AutoOptions.omlats);
      let nObject = {
        ...object,
        customer: newValue,
        end_Dept: end_dept1,
        notes: "دفعة من حساب " + newValue.name,
        cust_omlat: accOmlat ?? AutoOptions.omlats,
        cust_omla: accOmlat[0] ?? AutoOptions.omlats[0],
        emp: sto.User_typei == 1? newValue?.salesmen === 0 || newValue?.salesmen === -1 ?GetEmpFromOptions(sto.empi, AutoOptions.Users):
        AutoOptions.Users.find((obj) => obj.salesmen === newValue?.salesmen??0)??
        GetEmpFromOptions(sto.empi, AutoOptions.Users):object?.emp,
      };
      setEndBalance(end_dept1);
      onShow(nObject, formType);
    } else {
      setEndBalance(end_dept1);
    }
  };
  const changeAutoSalesman = async (newValue) => {
    if (newValue?.salesmen === 0 || newValue?.salesmen === -1) {
      let nObject = {
        ...object,
        emp: GetEmpFromOptions(sto.empi, AutoOptions.Users),
      };
      onShow(nObject, formType);
    } else {
      let res_salesman = AutoOptions.Users.find((obj) => obj.salesmen??-1 === newValue?.salesmen??0);
      if (res_salesman) {
        let nObject = {
          ...object,
          emp: res_salesman,
        };
        onShow(nObject, formType);
      }
    }
  }

  const changAutoStocks = async (newValue) => {
    const accOmlat = getAccountOmlat(newValue.acc_omlat ?? 1, AutoOptions.omlats);
    let nObject = {
      ...object,
      stock: newValue,
      stock_omlat: accOmlat ?? AutoOptions.omlats,
      stock_omla: accOmlat[0] ?? AutoOptions.omlats[0],
    };
    onShow(nObject, formType);
  };

  const changAutoBanks = async (newValue) => {
    const accOmlat = getAccountOmlat(newValue.acc_omlat, AutoOptions.omlats);
    let nObject = {
      ...object,
      bank: newValue,
      bank_omlat: accOmlat,
      bank_omla: accOmlat[0],
    };
    onShow(nObject, formType);
  };
  const onChangeAutoInv = async (newValue) => {
    setValueInv(newValue);
    let newObject = {
      ...object,
      proc_id: newValue.procId,
    };
    onShow(newObject, formType);
  };

  const classes = useStylesSand();
  const clashd = useStylesHed();
  const [file, setFile] = useState(null);
  const [files, setFiles] = useState([]);
  const addArchaive = async (data) => {
    let nameFile = "ExternalReceiptVouchar" +data.id+data.branch;
    // addArchaiveFile(files, nameFile);
    console.log("the datadata is", data);
    addMultiArchaiveFile(files, nameFile);
  };
  const handleDownload = async () => {
    try {
      let nameFile = "ExternalReceiptVouchar" + object.id + branch.id;
      await handleMultiDownloadFiles(nameFile);
    } catch (error) {
    }
  };
  return (
    <>
      <div className={isMobileDevice ? classes.root2 : classes.root} style={{ direction: "rtl" }}>
        <Grid item container className={clashd.rootHd}>
          <Grid item xs={12}>
            <Chip
              size="medium"
              className={clashd.ChipHdAccount}
              style={{ fontSize: "16px" }}
              label={t("translation:ext-receipt")}
              color="primary"
            />
          </Grid>
        </Grid>
        <Typography
          component="div"
          style={{ direction: "rtl", marginTop: "20px" }}
        >
          <Grid container justifyContent="center" spacing={3}>
            <Grid item lg={9} md={8} sm={12}>
              <Container
                component={Paper}
                maxWidth={false}
                style={{
                  padding: isMobileDevice ? "12px" : "30px",
                  // height:'400px',
                  borderTopColor: colors.grey[700],
                  borderTopWidth: "2px",
                  borderTopStyle: "solid",
                }}
              >
                {/* <SelectTypesFilter {...{rptParams, setRptParams }}/> */}
                <EReceiptVoucherForm
                  {...{
                    ...props,
                    object,
                    formType,
                    changAutoCustomers,
                    changAutoBanks,
                    changAutoStocks,
                    onChange,
                    onShow,
                    selectCustomer,
                    valueInv,
                    invOptions,
                    onChangeAutoInv,
                    AutoOptionsB,
                    branch,
                    setBranch,
                    branchT,
                    optionsStocks,
                    handleInputSearchCust,
                    optionsCustomers,
                    handleIconSearchCust,
                    prmis,
                    setFile,
                    handleDownload,
                    setFiles,
                    files,
                    db_name
                  }}
                />
                {/* <CurrencySalesProfitForm {...{AutoOptions, rptParams, onChangeData, onChangeAutoData}} /> */}
              </Container>
            </Grid>
            <Grid item lg={3} md={4} sm={12}>
              <TotalCard
                {...{
                  className: classes.card,
                  title: t("forms:account-balance-to-date"),
                  // value: getEndDept(object.end_Dept),
                  value: getEndDept(endBalance),

                }}
              />
              <br />
              <Container
                component={Paper}
                maxWidth={true}
                style={{
                  padding: "20px",
                  borderBottomWidth: "0px",
                }}
              >
                <Grid container justify="space-between">
                  <Grid item>
                    <Typography
                      style={{ paddingTop: "8px" }}
                      variant="h4"
                      component="h4"
                    >
                      {t("forms:check-data")}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Avatar className={classes.avatar}>
                      <AttachMoneyIcon className={classes.icon} />
                    </Avatar>
                  </Grid>
                </Grid>
                <Divider />
                <br />

                <ExternalFormSub
                  {...{
                    ...props,
                    object,
                    changAutoCustomers,
                    onChange,
                  }}
                />

                <br />
              </Container>
            </Grid>
          </Grid>
        </Typography>
      </div>
      <EReceiptVoucherAppBar
        {...{
          URL: EReceiptAPI.URL,
          prmis,
          ...props,
          onChange,
          submit,
          update,
          defaultV,
          remove,
          submitting,
          errorMessage,
          onShow,
          onEnd,
          object,
          formType,
          getRow,
          AutoOptions,
          selectCustomer,
          valueInv,
          invOptions,
          onChangeAutoInv,
          setInvOptions,
          setValueInv,
          setselectCustomer,
          branch,
          branchT,
          setBranchT,
          AutoOptionsB,
          setOptionsStocks,
          changAutoCustomers,
          endBalance,
          setEndBalance,
          setOptionsCustomers,
          optionsCustomers,
          setListSelectApi,
          file,
          addArchaive,
          setFiles,
          files,
          db_name
        }}
      />
    </>
  );
}
